import { useCartStore } from '@/stores/CartStore'
import { cartService } from './cartService'

export class CartProductService {
  private get store() {
    return useCartStore()
  }

  getQuantity(productId: number): number {
    return this.store.getProductQuantity(productId)
  }

  async add(productId: number): Promise<void> {
    await cartService.addProduct(productId, 1)
  }

  async increment(productId: number): Promise<void> {
    await cartService.updateProductQuantity(productId, 1)
  }

  async decrement(productId: number): Promise<void> {
    const item = this.store.getProductInCart(productId)
    if (!item) return
    if (item.quantity <= 1) {
      await cartService.deleteProduct(item.id)
    } else {
      await cartService.updateProductQuantity(productId, -1)
    }
  }
}
